// extracted by mini-css-extract-plugin
export var childrenContainer = "_1d-0";
export var virtualScrollArea = "_1d-1";